const isInIframe = window.self !== window.top
const parentOrigin = document.referrer
  ? (() => {
      try {
        return new URL(document.referrer).origin
      } catch {
        return '*'
      }
    })()
  : '*'

type BridgeReq = {
  type: 'H5_BRIDGE_REQ'
  id: string
  api: string
  payload: Record<string, any>
}
type BridgeRes = {
  type: 'H5_BRIDGE_RES'
  id: string
  success: boolean
  result?: any
  error?: any
}

const pendingMap = new Map<
  string,
  {
    resolve: (_v: any) => void
    reject: (_e: any) => void
    timeout: ReturnType<typeof setTimeout>
  }
>()

let attached = false
const genId = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`
const bridgeListener = (e: MessageEvent) => {
  const data = e.data as BridgeRes

  if (!data || data.type !== 'H5_BRIDGE_RES') {
    return
  }
  if (parentOrigin !== '*' && e.origin !== parentOrigin) {
    return
  }
  const pending = pendingMap.get(data.id)

  if (!pending) {
    return
  }
  clearTimeout(pending.timeout)
  pendingMap.delete(data.id)
  if (data.success) {
    pending.resolve(data.result)
  } else {
    pending.reject(data.error)
  }
}
const ensureListener = () => {
  if (!attached && isInIframe) {
    window.addEventListener('message', bridgeListener)
    attached = true
  }
}

export const callBridgeViaParent = (
  api: string,
  payload: Record<string, any>,
  timeoutMs = 8000
): Promise<any> => {
  ensureListener()
  return new Promise((resolve, reject) => {
    const id = genId()
    const req: BridgeReq = { type: 'H5_BRIDGE_REQ', id, api, payload }
    const timeout = setTimeout(() => {
      pendingMap.delete(id)
      reject(new Error('iframe bridge timeout'))
    }, timeoutMs)

    pendingMap.set(id, { resolve, reject, timeout })
    try {
      window.top?.postMessage(req, parentOrigin)
    } catch (err) {
      clearTimeout(timeout)
      pendingMap.delete(id)
      reject(err)
    }
  })
}

export const detachIframeBridge = () => {
  if (attached) {
    window.removeEventListener('message', bridgeListener)
    attached = false
  }
  pendingMap.clear()
}

export const useIframeBridge = () => ({
  isInIframe,
  callBridgeViaParent,
  detach: detachIframeBridge
})
